"use client";

/**
 * Public-site providers.
 *
 * The dark/light theme is driven entirely by:
 *   - the SSR-rendered `dark` class on `<html>` (set in `layout.tsx`, from
 *     `resolveTenantThemeModePolicy`), and
 *   - the inline pre-paint boot script (`THEME_BOOT_SCRIPT`, rendered by
 *     `ThemeBootScript` as the first thing in `<head>` in `layout.tsx` on
 *     full document loads only) — the actual source of truth,
 *     since only it can read `prefers-color-scheme` / a persisted visitor
 *     choice before first paint.
 *
 * The visitor sun/moon toggle (when Theme Design's "Allow visitors to switch
 * themes" is on) lives inside `ClassicHeader` (`packages/builder/runtime`) —
 * a plain `classList.toggle('dark')` + optional `localStorage` write, not a
 * React theme context. We deliberately do NOT mount `next-themes` here —
 * that would add client-side theme state and a hydration pass that could
 * fight the SSR class for no benefit, since the boot script + a small DOM
 * toggle already cover every case in `resolveVisitorThemeModePolicy`.
 */
export default function Providers({ children }: { children: React.ReactNode }) {
	return <>{children}</>;
}
